export default __webpack_public_path__ + "static/career-3d820670cd00e481d504c0798ce59191.jpg";